// extracted by mini-css-extract-plugin
export default {"carousel":"Carousel_carousel__rxJBY","carouselItem":"Carousel_carouselItem__kLefg","price":"Carousel_price__4qkwy"};